import { AppLink } from '../../components/AppLink';
import { Button } from '../../components/Button';
import { FlexColPageContainer } from '../../components/FlexColPageContainer';

export const metadata = {
  title: 'Patches | Patchooli',
  description: 'Patches | Patchooli',
};

export const PatchesPage = () => {
  return (
    <FlexColPageContainer>
      <div>PatchesPage</div>
      <Button variant="buttonPrimary" as={AppLink} href="/mood-log-entry/step1">
        Go to Mood Log Entry
      </Button>
    </FlexColPageContainer>
  );
};
